import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface CardProps extends HTMLMotionProps<'div'> {
  children: React.ReactNode;
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false,
  ...props
}: CardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className={`bg-[var(--surface)] rounded-xl shadow-sm border border-gray-100 overflow-hidden ${noPadding ? '' : 'p-6'} ${className}`} {...props} data-id="element-210">
      {children}
    </motion.div>;
}